import IuranAnggotaPresenter from "../../../presenter/menu_anggota/iuran-anggota-presenter.js";
import ImagePopUPInitiator from '../../../presenter/pop-up-presenter.js';




const IuranAnggota = {
	async render() {
		const view = `
		<!-- DataTales Example -->
        <div class="row">
            <div class="col-sm-4">
                <div class="card shadow mb-4">
                    <div class="card-header text-primary font-weight-bold">
                        STATUS IURAN ANGGOTA
                    </div>
                    <div class="card-body">
                        <h5>STATUS : <u id="statusIuran" class="font-weight-bold"><div class="shimmer title-line end"></div></u></h5>
                        <div id="warning-iuran" class="alert alert-warning font-weight-bold"><i>Segera lakukan pembayaran Iuran untuk dapat mengakses fitur pelayanan anggota !</i></div>
                        <hr style="margin-bottom: 10px">
                        <div class="row mb-3" id="downloadBuktiIuranContent">
                            <div class="col-md-12 mb-2">
                                <strong>Download Bukti Iuran</strong><br>
                                <select id="filter-year" class="form-control">
                                    <option value="">Pilih Tahun</option>
                                </select>
                            </div>
                            <div class="col-md-12">
                                <button class="btn btn-primary" id="btn-download-bukti">
                                    <i class="fas fa-download"></i> Download
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card shadow mb-4">
                    <div class="card-header text-primary font-weight-bold">
                        TAGIHAN IURAN BULANAN
                    </div>
                    <div class="card-body">
                        <h5>Jumlah Tagihan Iuran : </h5>
                        <h3 class="font-weight-bold" id="nominalIuran"><div class="shimmer title-line end"></div></h3>
                        <h5>Lakukan pembayaran sebelum : <u id="jatuhTempo"><div class="shimmer title-line"></div></u></h5>
                    </div>
                </div>
            </div>
            
            <div class="col-sm-8">
                <div class="card shadow mb-4">
                    <div class="card-header text-primary font-weight-bold">
                        FORMULIR PEMBAYARAN IURAN
                    </div>
                    <div class="card-body">
                        <div class="alert alert-info">
                            <h5 class="font-weight-bold">Informasi Rekening :</h5>
                            <div id="informasiRekening">
                                <div class="shimmer title-line end"></div>
                            </div>
                        </div>
                        <div class="row">
                            
                            <div class="col-sm-6">
                                <div class="form-group row">
                                    <label class="control-label col-sm-12 font-weight-bold">Dari Bulan</label>
                                    <div class="col-sm-12">
                                        <input type="month" class="form-control" id="startBulan">
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-6">
                                <div class="form-group row">
                                    <label class="control-label col-sm-12 font-weight-bold">Sampai Bulan</label>
                                    <div class="col-sm-12">
                                        <input type="month" class="form-control" id="endBulan">
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-12">
                                <div class="form-group">
                                    <label class="control-label col-sm-12 font-weight-bold">Jumlah Yang Harus Dibayar</label>
                                    <div class="alert alert-primary col-sm-12 font-weight-bold"><span id="jmlIuran">Rp.-</span> x <span id="jmlBulan">0</span> Bulan = <span id="totalIuran">Rp.0</span></div>
                                </div>
                            </div>
                        </div>
                        <!--<label class="control-label font-weight-bold">Bukti Bayar</label>
                        <div id="form-upload-bukti-bayar-iuran" class="col-sm-12 dropzone">
                            <input type="hidden" name="file" style=""/>
                        </div>-->
                        <button class="btn btn-primary" id="btnRequestInvoice">
                            <i class="fas fa-file-invoice-dollar"></i> Buat Invoice
                        </button>
                    </div>
                </div>
            </div>

            <div class="col-sm-12">
            <div class="card shadow mb-4">
                <div class="card-header text-primary font-weight-bold">
                    DATA INVOICE PEMBAYARAN IURAN
                </div>
                <div class="card-body">
                    <table class="table table-bordered" id="historyPembayaran">
                        <thead>
                            <tr>
                                <th>ID</th>
                                <th>Tanggal</th>
                                <th>Keterangan</th>
                                <th>Jumlah Bayar</th>
                                <th>Berlaku Sampai</th>
                                <th>Status Pembayaran</th>
                                <th>Bukti Bayar</th>
                                <th>PD</th>
                                <th>PC</th>
                                <th>Aksi</th>
                            </tr>
                        </thead>
                        <tbody id="contentHistory">
                            <tr>
                                <td><div class="shimmer title-line end"></div></td>
                                <td><div class="shimmer title-line"></div></td>
                                <td><div class="shimmer title-line"></div></td>
                                <td><div class="shimmer title-line"></div></td>
                                <td><div class="shimmer title-line"></div></td>
                                <td><div class="shimmer title-line"></div></td>
                                <td><div class="shimmer circle"></div></td>
                                <td><div class="shimmer title-line"></div></td>
                                <td><div class="shimmer title-line"></div></td>
                                <td><div class="shimmer title-line end"></div></td>
                            </tr>
                            <tr>
                                <td><div class="shimmer title-line end"></div></td>
                                <td><div class="shimmer title-line"></div></td>
                                <td><div class="shimmer title-line"></div></td>
                                <td><div class="shimmer title-line"></div></td>
                                <td><div class="shimmer title-line"></div></td>
                                <td><div class="shimmer title-line"></div></td>
                                <td><div class="shimmer circle"></div></td>
                                <td><div class="shimmer title-line"></div></td>
                                <td><div class="shimmer title-line"></div></td>
                                <td><div class="shimmer title-line end"></div></td>
                            </tr>
                            <tr>
                                <td><div class="shimmer title-line end"></div></td>
                                <td><div class="shimmer title-line"></div></td>
                                <td><div class="shimmer title-line"></div></td>
                                <td><div class="shimmer title-line"></div></td>
                                <td><div class="shimmer title-line"></div></td>
                                <td><div class="shimmer title-line"></div></td>
                                <td><div class="shimmer circle"></div></td>
                                <td><div class="shimmer title-line"></div></td>
                                <td><div class="shimmer title-line"></div></td>
                                <td><div class="shimmer title-line end"></div></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
            
            
        </div>
        <div class="modal fade" id="commentModalIuran" tabindex="-1" role="dialog" aria-labelledby="commentModal"
        aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header text-primary font-weight-bold">
                        Komentar Iuran
                        <button class="close" type="button" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">×</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-sm-12">
                            
                                <input type="hidden" id="textInvoiceIdComment"/>
                                <div class="chat-body" id="content-comment"  style="height:400px; overflow-y:auto">
                                    <div style="width:100%">
                                        <div style="width:10%;" class="float-left">
                                            <div class="shimmer circle"></div>
                                        </div>
                                        <div class="float-left text-dark text-left bubble-shimmer-left" style="width:88%;">
                                            <div class="shimmer content-line"></div>
                                            <div class="shimmer content-line"></div>
                                            <div class="shimmer content-line end"></div>
                                        </div>
                                    </div>
                                    <div style="width:100%">
                                        <div style="width:10%;" class="float-right">
                                            <div class="shimmer circle"></div>
                                        </div>
                                        <div class="float-right text-dark text-left bubble-shimmer-right" style="width:88%;">
                                            <div class="shimmer content-line"></div>
                                            <div class="shimmer content-line"></div>
                                            <div class="shimmer content-line end"></div>
                                        </div>
                                    </div>
                                    <div style="width:100%">
                                        <div style="width:10%;" class="float-left">
                                            <div class="shimmer circle"></div>
                                        </div>
                                        <div class="float-left text-dark text-left bubble-shimmer-left" style="width:88%;">
                                            <div class="shimmer content-line"></div>
                                            <div class="shimmer content-line"></div>
                                            <div class="shimmer content-line end"></div>
                                        </div>
                                    </div>
                                    <div style="width:100%">
                                        <div style="width:10%;" class="float-right">
                                            <div class="shimmer circle"></div>
                                        </div>
                                        <div class="float-right text-dark text-left bubble-shimmer-right" style="width:88%;">
                                            <div class="shimmer content-line"></div>
                                            <div class="shimmer content-line"></div>
                                            <div class="shimmer content-line end"></div>
                                        </div>
                                    </div>
                                </div>
                                <form id="form-comment-user-ktan">
                                    <label class="control-label font-weight-bold">Komentar</label>
                                    <textarea class="form-control" id="komentarPengajuanSKP" name="komentar" placeholder="Komentar..." required></textarea>
                                    <br>
                                    <button type="button" class="form-control btn btn-sm btn-primary" id="btnSendKomentarPengajuanSKP"><i class='fas fa-comment'></i> Berikan Komentar</button>
                                </form>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button class="btn btn-secondary" id="btnCancel" type="button" data-dismiss="modal">Cancel</button>
                    </div>
                </div>
            </div>
        </div>
        
    <div class="modal fade" id="modalBayarIuran" tabindex="-1" role="dialog" aria-labelledby="modalBayarIuran"
    aria-hidden="true">
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Upload Bukti Bayar</h5>
                    <button class="close" type="button" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">×</span>
                    </button>
                </div>
                <div class="modal-body" id="ttd">
                    <div class="alert alert-info">
                        <h5 class="font-weight-bold">Informasi Rekening :</h5>
                        <div id="informasiRekening2">

                        </div>
                    </div>
                    <label>Upload Bukti Bayar : </label>
                    <input type="hidden" id="textInvoiceId"/>
                    <div id="form-upload-bukti-bayar-iuran" class="col-sm-12 dropzone">
                        <input type="hidden" name="file" style=""/>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-primary" id="btnSaveIuran">Kirim Bukti Bayar</button>
                    <button class="btn btn-secondary" id="btnCancel" type="button" data-dismiss="modal">Cancel</button>
                </div>
            </div>
        </div>
    </div>
	<div style="display:none;" id="my-template">
        <div id="mytmp" class="dz-preview dz-file-preview">
            <div class="dz-image"><img loading="lazy" data-dz-thumbnail width="200px" /></div>
            <div class="dz-details">
                <div class="dz-size"><span data-dz-size></span></div>
                <div class="dz-filename"><span data-dz-name></span></div>
            </div>
            
            <div class="dz-error-message"><span data-dz-errormessage></span></div>
            <div class="dz-success-mark">
                <svg xmlns="http://www.w3.org/2000/svg" height="54px" viewBox="0 0 54 54" width="54px" fill="#000000">
                    <path d="M0 0h24v24H0z" fill="none" />
                    <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" />
                </svg>
            </div>
            <div class="dz-error-mark">
                <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000">
                    <path d="M0 0h24v24H0z" fill="none" />
                    <circle cx="12" cy="19" r="2" />
                    <path d="M10 3h4v12h-4z" />
                </svg>
            </div>
            <div class="dz-remove" data-dz-remove>
                <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000">
                    <path d="M0 0h24v24H0z" fill="none" />
                    <path d="M14.59 8L12 10.59 9.41 8 8 9.41 10.59 12 8 14.59 9.41 16 12 13.41 14.59 16 16 14.59 13.41 12 16 9.41 14.59 8zM12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z" />
                </svg>
            </div>
        </div>
    </div>


        `;
		return view;
	  },

	async afterRender() {
		await IuranAnggotaPresenter.init()
		await ImagePopUPInitiator.init()
	},

	_errorContent(container) {
		const errorContent = document.getElementById('main-content');
		errorContent.innerHTML = `<div class="msg-failed">
                             <span class="fa fa-pencil"></span>
                              <p class="center">Maaf , Aplikasi tidak dapat di tampilkan. Periksa kembali internet anda ya &#128522</p>
                             </div>`;
	},

};

export default IuranAnggota;